var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Schema, type } from "@colyseus/schema";
/**
 * A simulated mall-goer. Server-owned (NpcDirector) and synced to every
 * client so the whole room sees the same crowd in the same places.
 */
export class Npc extends Schema {
    constructor() {
        super(...arguments);
        this.id = "";
        this.x = 0;
        this.y = 0;
        this.z = 0;
        this.rotation = 0;
        /** One of NpcActivity. Sent as a string to stay readable on the wire. */
        this.activity = "walk";
        /** Stable per-NPC number the client hashes into variant + outfit colors. */
        this.appearance = 0;
        /** True once the shopper has "bought" something; renders a bag in hand. */
        this.hasBag = false;
    }
}
__decorate([
    type("string")
], Npc.prototype, "id", void 0);
__decorate([
    type("number")
], Npc.prototype, "x", void 0);
__decorate([
    type("number")
], Npc.prototype, "y", void 0);
__decorate([
    type("number")
], Npc.prototype, "z", void 0);
__decorate([
    type("number")
], Npc.prototype, "rotation", void 0);
__decorate([
    type("string")
], Npc.prototype, "activity", void 0);
__decorate([
    type("number")
], Npc.prototype, "appearance", void 0);
__decorate([
    type("boolean")
], Npc.prototype, "hasBag", void 0);
//# sourceMappingURL=Npc.js.map